import { state } from './state'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'

export const MODULE_NAME = 'signIn'

const SignInModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default SignInModule



// WEBPACK FOOTER //
// ./src/store/module/signIn/index.js